import { types, type Instance } from 'mobx-state-tree';

/**
 * UI State related to a whole project
 *
 * Most project actions (change settings, check model, etc.) are handled in a
 * modal. This store contains the state of which modal is open.
 */
const UIProject = types
  .model('UIProject', {
    // is something busy
    busy: false,
    // is the change settings modal open?
    changeSettings: false,
    // is the check model modal open?
    checkModel: false,
    // is the check model modal checking an FSM? Which one?
    checkFSM: types.maybe(types.string),
    // is the export model modal open?
    exportModel: false,
    // is the export edg image modal open?
    exportEDGImage: false,
    // is the export oet image modal open?
    exportOETImage: false,
    // is the export oet csv modal open?
    exportOETCsv: false,
    // is the export fsm image model open?
    exportFSMImage: false,
    // is the learning report modal open?
    learningReport: false,
    // is the save as modal open?
    saveAs: false,
    // is the save version modal open?
    saveVersion: false,
    // is the restore version modal open?
    restoreVersion: types.maybeNull(types.string),
  })
  .views((self) => ({}))
  .actions((self) => ({
    setBusy(busy: boolean) {
      self.busy = busy;
    },
    setChangeSettings(editing: boolean) {
      self.changeSettings = editing;
    },
    setCheckModel(check: boolean, fsm?: string) {
      self.checkModel = check;
      self.checkFSM = fsm;
    },
    setExportModel(exporting: boolean) {
      self.exportModel = exporting;
    },
    setExportEDGImage(exporting: boolean) {
      self.exportEDGImage = exporting;
    },
    setExportOETImage(exporting: boolean) {
      self.exportOETImage = exporting;
    },
    setExportOETCsv(exporting: boolean) {
      self.exportOETCsv = exporting;
    },
    setExportFSMImage(exporting: boolean) {
      self.exportFSMImage = exporting;
    },
    setLearningReport(report: boolean) {
      self.learningReport = report;
    },
    setSaveAs(saving: boolean) {
      self.saveAs = saving;
    },
    setSaveVersion(saving: boolean) {
      self.saveVersion = saving;
    },
    setRestoreVersion(id: string | null) {
      self.restoreVersion = id;
    },
  }));

export type IUIProject = Instance<typeof UIProject>;

export default UIProject;
